// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"471b97d36ff57d74c0ee","293":"d53eea358abb296e037e"}[chunkId] + ".js";
};